import { type Visit } from '@/services/visitsService/types';
import { FlowTypes } from '@/utils/analytics';

export const getEventFlowValueFromVisitType = (visit?: Visit) => {
  if (!visit) {
    return undefined;
  }

  const visitTypeSlugToFlowMap: Record<string, string> = {
    'express-curology-sign-up-skin': FlowTypes.PDP_CHECKOUT,
  };

  return visitTypeSlugToFlowMap[visit.visitType.slug] ?? undefined;
};
